import React from "react";
import {observer} from "mobx-react-lite";

import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";

import systemStore from "../storage/SystemStore";


const isEmptyValue = (value) => {
    if (value === null || value === undefined) {
        return true;
    }

    if (typeof value === "string") {
        return value.trim() === "";
    }

    return false;
};


const Input = ({
    type = "text",
    label,
    placeholder,
    store,
    prop,
    className = "",
    inputClassName = "",
    required = false,
    full = true,
    small = false,
    value,
    onChange,
    disabled = false,
    invalid: invalidProp,
    min = 0,
    ...rest
}) => {

    const storeBound =
        store !== undefined &&
        prop !== undefined;


    const inputValue =
        storeBound
            ? store[prop]
            : value;


    const isDisabled =
        disabled ||
        systemStore.loading;


    const invalid =
        invalidProp ??
        (
            required &&
            storeBound &&
            Boolean(store?.was_validated) &&
            isEmptyValue(inputValue)
        );


    const inputPlaceholder =
        placeholder ?? label;


    const rootClassName = [
        full && "w-full",
        small && "p-inputtext-sm",
        invalid && "p-invalid",
        className,
    ]
        .filter(Boolean)
        .join(" ");


    const handleTextChange = (event) => {
        const nextValue = event.target.value;

        if (storeBound) {
            store.setProperty(prop, nextValue);
        }

        onChange?.(event);
    };


    const handleNumberChange = (event) => {
        const nextValue = event.value ?? null;

        if (storeBound) {
            store.setProperty(prop, nextValue);
        }

        onChange?.(event);
    };


    const handleFileChange = (event) => {
        const nextValue =
            event.target.files?.[0] || null;

        if (storeBound) {
            store.setProperty(prop, nextValue);
        }

        onChange?.(event);
    };


    /* =====================================================
       NUMBER
       ===================================================== */

    if (type === "number") {
        const numberInputClassName = [
            small && "p-inputtext-sm",
            inputClassName,
        ]
            .filter(Boolean)
            .join(" ");

        return (
            <InputNumber
                {...rest}

                value={inputValue ?? null}

                placeholder={inputPlaceholder}

                min={min}

                disabled={isDisabled}
                required={required}
                invalid={invalid}

                className={rootClassName}
                inputClassName={numberInputClassName}

                onValueChange={handleNumberChange}
            />
        );
    }


    /* =====================================================
       FILE
       ===================================================== */

    if (type === "file") {
        const fileClassName = [
            "p-inputtext",
            "p-component",
            full && "w-full",
            invalid && "p-invalid",
            className,
        ]
            .filter(Boolean)
            .join(" ");

        return (
            <input
                {...rest}

                type="file"

                className={fileClassName}

                disabled={isDisabled}
                required={required}

                aria-invalid={
                    invalid
                        ? "true"
                        : undefined
                }

                onChange={handleFileChange}
            />
        );
    }


    /* =====================================================
       TEXT / EMAIL / PASSWORD / DATE / TEL / ETC.
       ===================================================== */

    return (
        <InputText
            {...rest}

            type={type}

            value={inputValue ?? ""}

            placeholder={inputPlaceholder}

            disabled={isDisabled}
            required={required}
            invalid={invalid}

            className={rootClassName}

            onChange={handleTextChange}
        />
    );
};


export default observer(Input);